import type { AppConfig } from "../../types/appConfig";
import type { TheoryTest, TheoryTestSubmission, TheoryTestTemplate } from "./TheoryTest.typed";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";

export class TheoryTestModel {
  private zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async getPublicTheoryTestTemplate(
    trainingTemplateId: string,
    token: string,
  ): Promise<TheoryTestTemplate | null> {
    const response = await fetchZekay(
      `${this.zekayAPI}/theorytests/templates/${trainingTemplateId}/public`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    await expectStatuses(response, 200, 204);
    if (response.status === 204) return null;
    const data = (await response.json()) as TheoryTestTemplate;

    return data.Online ? data : null;
  }

  async submitTheoryTest(
    trainingTemplateId: string,
    userId: string,
    data: TheoryTestSubmission,
    token: string,
  ): Promise<TheoryTest> {
    const response = await fetchZekay(
      `${this.zekayAPI}/theorytests/${trainingTemplateId}/${userId}/submit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(data),
      },
    );
    await assertResponseOk(response);

    return (await response.json()) as TheoryTest;
  }
}
